import { TrendingDown, TrendingUp } from 'lucide-react';
import { cn } from '../../../../lib/utils';
import type { StatBlock } from '../chat-content';

export function StatBlockRenderer({ block }: { block: StatBlock }) {
  return (
    <div
      className={cn(
        'grid gap-3 w-full',
        block.items.length === 1 && 'grid-cols-1',
        block.items.length === 2 && 'grid-cols-2',
        block.items.length >= 3 && 'grid-cols-2 sm:grid-cols-3',
      )}
    >
      {block.items.map((item, i) => (
        <div key={i} className="rounded-lg border border-border bg-card px-4 py-3 space-y-1">
          <p className="text-xs text-muted-foreground truncate">{item.label}</p>
          <p className="text-xl font-semibold text-foreground tabular-nums leading-none">
            {item.prefix && (
              <span className="text-sm font-normal text-muted-foreground mr-0.5">
                {item.prefix}
              </span>
            )}
            {item.value}
            {item.suffix && (
              <span className="text-sm font-normal text-muted-foreground ml-0.5">
                {item.suffix}
              </span>
            )}
          </p>
          {item.delta && (
            <p
              className={cn(
                'flex items-center gap-1 text-xs font-medium',
                item.trend === 'up' && 'text-success',
                item.trend === 'down' && 'text-destructive',
                (!item.trend || item.trend === 'neutral') && 'text-muted-foreground',
              )}
            >
              {item.trend === 'up' && <TrendingUp className="size-3 shrink-0" />}
              {item.trend === 'down' && <TrendingDown className="size-3 shrink-0" />}
              {item.delta}
            </p>
          )}
        </div>
      ))}
    </div>
  );
}
